
const notifyParent = (action, data, { parent, document } = window) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(
      `%cnotifyParent`,
      'color: purple; font-weight:bold',
      action,
      data
    )
  }

  parent && parent.postMessage({ action, data }, getTargetOrigin(document))
}

const getTargetOrigin = ({ location } = document) => {
  let origin = ''
  try {
    origin = location.ancestorOrigins[0]
  } catch (err) {
    origin = '*'
  }
  return origin !== undefined ? origin : '*'
}

export default notifyParent
